/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Job } from '../../models/job';

export interface UpdateJobTime$Params {
   /**
    * Time in format HH:SS when daily job started
    */
   time: string;
}

export function updateJobTime(
   http: HttpClient,
   rootUrl: string,
   params: UpdateJobTime$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Job>> {
   const rb = new RequestBuilder(rootUrl, updateJobTime.PATH, 'put');
   if (params) {
      rb.query('time', params.time, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Job>;
      })
   );
}

updateJobTime.PATH = '/api/weather/job/time';
